{
  "pt": {
    "message": {
      "actions": {
        "delete_message": "Apagar mensagem",
        "move_selected": "Mover mensagens seleccionadas",
        "send": "Enviar"
      },
      "labels": {
        "already_replied": "já tem uma resposta",
        "cannot_delete_message": "Esta mensagem já foi lida pelo cliente, pelo que não pode ser apagada.",
        "changes_not_saved": "Tem alterações não guardadas. Tem a certeza de que quer continuar?\np.s.: Pode abrir um novo separador para navegar para outras páginas em simultâneo.",
        "delete_message": "Isto elimina a mensagem para todos. Tenha em atenção que pode já ter sido enviada uma notificação por correio eletrónico, dependendo das definições do destinatário.",
        "delete_message_abort": "A mensagem não pode ser apagada",
        "move_customer_notification": "O cliente será notificado quando a mensagem for transferida para outra conversa",
        "move_to": "Mover mensagem para...",
        "moved_here": "aqui da conversa",
        "moved_message": "moveu esta mensagem",
        "moving_message": "Mensagem em movimento",
        "notSeenYet": "Ainda não visto",
        "seen_by": "Visto por {participants}",
        "to": "para",
        "you": "tu"
      },
      "validation": {
        "message_required": "A mensagem é necessária"
      }
    }
  }
}
